<div class="container" *ngIf="learningActivity">
  <app-assignment-view *ngIf="isAssignment"
                       [learningActivity]="learningActivity"
                       [assignmentId]="learningActivity.materialId"></app-assignment-view>
  <app-lesson-view *ngIf="isLesson"
                   [learningActivity]="learningActivity"
                   [lessonId]="learningActivity.materialId">
  </app-lesson-view>
</div>
